export class CheckTaskExistResultModel {
  /**
   * * Наличие задачи
   */
  IsExists: boolean = false;
  /**
   * * Номер задачи
   */
  TaskId?: number;
  /**
   * * Номер очереди
   */
  QueueTaskId?: string;
  /**
   * * Номер рабочей области
   */
  NamespaceId?: string;
  /**
   * * Номер проекта
   */
  ProjectId?: number;

  constructor(obj?: Partial<CheckTaskExistResultModel>) {
    Object.assign(this, obj);
  }
}
